<template>
  <div
    id="joy-game"
    class="joy-game"
    v-show="!isHidden"
    v-if="!isClose"
    @click.stop
  >
    <div class="action">
      <img
        src="./images/hidden.png"
        alt=""
        srcset=""
        class="btn-hidden"
        @click="hiddenGame()"
      />
      <img
        src="./images/close.png"
        alt=""
        srcset=""
        class="btn-close"
        @click="closeGame()"
      />
    </div>
    <iframe :src="src" v-if="src"></iframe>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'JoyGame',
  props: {},
  data() {
    return {
      isHidden: true,
      isClose: true
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['token']),
    src() {
      return this.token
        ? process.env.NODE_ENV === 'production'
          ? `https://joysdk.com/00hall/?appKey=tvry0lv6wsgevdfpwq7y&lan=tw&token=${this.token}&mini=1&safeTop=20`
          : `https://test.joysdk.com/?appKey=tvry0lv6wsgevdfpwq7y&lan=tw&token=${this.token}&mini=1&safeTop=20`
        : '';
    }
  },
  methods: {
    show() {
      this.isClose = false;
      this.isHidden = false;
    },
    closeGame() {
      this.isClose = true;
    },
    hiddenGame() {
      this.isHidden = true;
    }
  }
};
</script>
<style lang="scss">
#joy-game {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 520px;
  z-index: 10;
  .action {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    align-items: center;
    img {
        width: 30px;
        height: 30px;
        object-fit: cover;
        margin-left: 10px;
    }
  }
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
